import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var MusicNote01 = function MusicNote01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M9 18V6.3554c0-.4816 0-.7223.0876-.9176a1 1 0 0 1 .3587-.4234c.1782-.1185.4157-.1581.8907-.2373l8.8-1.4666c.6409-.1069.9614-.1603 1.2112-.0675a1 1 0 0 1 .5192.4399C21 3.9139 21 4.2389 21 4.8887V16M9 18c0 1.6568-1.3431 3-3 3s-3-1.3432-3-3 1.3431-3 3-3 3 1.3431 3 3m12-2c0 1.6568-1.3431 3-3 3s-3-1.3432-3-3 1.3431-3 3-3 3 1.3431 3 3"
    })
  }));
};
export default MusicNote01;